import { Wave } from '../../wave/types/wave.type';
import { isWaveOfType } from '../../wave/utils/wave.util';
import { LaddergramCircle } from '../components/LaddergramCircle';
import { LaddergramEmptyCircle } from '../components/LaddergramEmptyCircle';
import { LaddergramLightning } from '../components/LaddergramLightning';
import { LaddergramSquare } from '../components/LaddergramSquare';
import { LaddergramTriangle } from '../components/LaddergramTriangle';
import { GRID_UNIT_SIZE } from './graph.utils';
import { isType } from './laddergram';

export interface TagShapeProps {
  color?: string;
  bordered: boolean;
  size: number;
}

export type TagType =
  | 'paced'
  | 'junctional'
  | 'ectopic'
  | 'default'
  | 'noisy_rr'
  | 'none';

export const getLaddergramType = (wave: Wave | undefined): TagType => {
  if (wave == null) {
    return 'default';
  }

  if (!isWaveOfType(wave, 'QRS', 'P')) {
    return 'none';
  }

  if (isType(wave.tags, 'noisy_rr')) {
    return 'noisy_rr';
  }

  if (isType(wave.tags, 'paced')) {
    return 'paced';
  }

  if (isType(wave.tags, 'junctional')) {
    return 'junctional';
  }

  if (isType(wave.tags, 'ectopic')) {
    return 'ectopic';
  }

  return 'default';
};

export const getScatterContent = (
  wave: Wave | undefined,
  size: number,
  color: string,
): JSX.Element => {
  switch (getLaddergramType(wave)) {
    case 'noisy_rr':
      return <circle r={size / 2} fill='transparent' stroke={color} />;
    case 'paced':
    case 'junctional':
    case 'ectopic':
    case 'default':
      return <circle r={size / 2 - GRID_UNIT_SIZE} fill={color} />;
    default:
      return <></>;
  }
};

export const getContent = (
  wave: Wave | undefined,
  { ...shapeProps }: TagShapeProps,
): JSX.Element => {
  switch (getLaddergramType(wave)) {
    case 'paced':
      return <LaddergramLightning {...shapeProps} />;
    case 'junctional':
      return <LaddergramTriangle {...shapeProps} />;
    case 'ectopic':
      return <LaddergramSquare {...shapeProps} />;
    case 'noisy_rr':
      return <LaddergramEmptyCircle {...shapeProps} />;
    case 'default':
      return <LaddergramCircle {...shapeProps} />;
    default:
      return <></>;
  }
};
